import { generatePath } from "react-router";

const traditionalClubWebUrl = new URL(
  import.meta.env.VITE_TRADITIONAL_CLUB_WEB_URL,
);
const basePath = traditionalClubWebUrl.pathname.replace(/\/+$/, "");

export const isTraditionalClubs = () =>
  location.origin === traditionalClubWebUrl.origin &&
  (location.pathname === basePath ||
    location.pathname.startsWith(`${basePath}/`));

export const routes = {
  selectClub: basePath || "/",
  club: `${basePath}/klubb/:clubId`,
  member: `${basePath}/klubb/:clubId/medlem/:memberId`,
  memberRegistration: `${basePath}/klubb/:clubId/medlem/:memberId/registrering`,
  addMember: `${basePath}/klubb/:clubId/ny-medlem/:step?`,
  addExistingMember: `${basePath}/klubb/:clubId/existerande-medlem`,
} as const;

export const addMemberSteps = {
  fideId: "fide-id",
  memberDetails: "uppgifter",
} as const;

export type AddMemberStep =
  (typeof addMemberSteps)[keyof typeof addMemberSteps];

export function generateAddMemberPath(
  clubId: number,
  step: AddMemberStep,
  fideId = "",
) {
  const pathname = generatePath(routes.addMember, {
    clubId: String(clubId),
    step,
  });
  return fideId ? `${pathname}?${new URLSearchParams({ fideId })}` : pathname;
}
